<template>
    <div>
       <!-- <div class="lke-tab">
           <div class="lke-tab-top">
               <i class="el-icon-s-goods"></i>学习状态
           </div>
           <div class="lke-tab-fot">
               <div class="lke-tab1">
                   <div class="lke-tab1in">
                       <div class="lke-tab1in-top">
                           <i class="el-icon-star-on"></i>
                           课程进度
                       </div>
                       <div class="lke-tab1in-fot">
                           <span>全部课程</span>
                           <div>
                               <el-progress :text-inside="true" :stroke-width="26" :percentage="Math.round(num*100)"></el-progress>
                           </div>
                       </div>
                   </div>
               </div>
           </div>
       </div> -->
       <div class="lke-tab">
           <div class="lke-tab-top">
               <i class="el-icon-s-goods"></i>课程评估
           </div>
           <div class="lke-tab-fot">
               <div class="lke-tab2">
                   <div class="lke-tab2-top">
                       <p>本调查旨在了解大家的学习情况，以便更好地改进教学工作，本问卷为匿名形式，不涉及对企业和个人的具体评价，请您不要有任何顾虑。非常感谢您的支持与配合！</p>
                   </div>
                   <div class="lke-tab2-fot">
                       <button class="lke-tab2-button" @click="openRouter('courseAssess')">课程评估</button>
                   </div>
               </div>
           </div>
       </div>
    </div>
</template>

<script>
export default {
    name: 'indexR',
    props: {
        num: Number,
    },
    data() {
        return {

        };
    },
    computed: {

    },
    created() {

    },
    mounted() {

    },
    watch: {

    },
    methods: {

        openRouter(val){
             this.$router.push({ name: val });
        }

    },
    components: {

    },
};
</script>

<style>
.el-progress-bar__outer{
    height: 20px !important;
}
</style>

<style scoped>
.lke-tab{
    border: 1px solid #ccc;
    margin-bottom: 20px;
}
.lke-tab-top{
    padding: 10px 15px;
    background: #F7F7F7;
    border-bottom: 1px solid #ccc;
    font-size: 18px;
    display: flex;
    align-items: center;
    font-weight: bold;
    color: #2890F4;
}
.lke-tab-top > i{
    font-size: 30px;
    padding-right: 5px;
}
.lke-tab-fot{
    padding: 15px;
}
.lke-tab1in-top > i{
    font-size: 18px;
    color: #2890F4;
}
.lke-tab1in-fot{
    display: flex;
    align-items: center;
    padding: 10px 0;
    padding-left: 25px;
}
.lke-tab1in-fot > span{
    font-size: 12px;
    color: #888888;
    padding-right: 10px;
}
.lke-tab1in-fot > div{
    flex: 1;
}
.lke-tab2-top{
    letter-spacing: 1px;
    font-size: 16px;
    line-height: 1.8;
    color: #888888;
}
.lke-tab2-fot{
    padding: 10px;
    padding-top: 20px;
    display: flex;
    justify-content: center;
}
.lke-tab2-fot > button{
    border: none;
    background: #E2B27B;
    padding: 4px 15px;
    color: #633501;
    cursor: pointer;
    border-radius: 2px;
    font-weight: bold;
}
.lke-tab2-fot > button:hover{
    background: #FFDC7D;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/page/grzx/components/indexR.vue